/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { ModelUtils } from '../../cmd/util/ModelUtils';
import { Node } from '../../core/models/Node';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiMessageBase } from './AaiMessageBase';
import { AaiMessageTrait } from './AaiMessageTrait';
import { AaiTag } from './AaiTag';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiMessageBase
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiMessage extends AaiMessageBase {
    /**
     * The message may be "composite".
     * In this case, nested messages are stored here.
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#a-name-operationobject-a-operation-object">AsyncAPI 2.0.0 spec</a>
     */
    public oneOf : Array<AaiMessage>;

    public _isOneOfMessage : boolean;

    /**
     * Objects of `any` type are deserialized as follows:
     * In TypeScript, this field contains the raw JS object, in case of Java
     * it is a {@link com.fasterxml.jackson.databind.node.ObjectNode}.
     * 
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#messageObject">AsyncAPI 2.0.0 spec</a>
     */
    public payload : any;

    public traits : Array<AaiMessageTrait>;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
            this._isOneOfMessage = false;
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
            this._isOneOfMessage = false;
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
            this._isOneOfMessage = false;
            if(this.oneOf===undefined) this.oneOf = null;
            if(this.payload===undefined) this.payload = null;
            if(this.traits===undefined) this.traits = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitMessage(this);
    }

    /**
     * Add a oneOf message.
     * @param {AaiMessage} item
     * @return
     * @param {number} index
     */
    public addOneOfMessage(item : AaiMessage, index : number) {
        if(this.oneOf == null) this.oneOf = <any>([]);
        if(ModelUtils.isNullOrUndefined(index)) {
            /* add */(this.oneOf.push(item)>0);
        } else {
            /* add */this.oneOf.splice(index, 0, item);
        }
    }

    /**
     * Delete a oneOf message.
     * @param {number} index
     * @return
     * @return {AaiMessage}
     */
    public deleteOneOfMessage(index : number) : AaiMessage {
        if(this.oneOf != null) return /* remove */this.oneOf.splice(index, 1)[0];
        return null;
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiMessageBase#addTag(io.apicurio.datamodels.asyncapi.models.AaiTag)
     * @param {AaiTag} tag
     */
    public addTag(tag : AaiTag) {
        if(this.tags == null) {
            this.tags = <any>([]);
        }
        /* add */(this.tags.push(tag)>0);
    }

    /**
     * @param {AaiMessageTrait} traitModel
     */
    public addTrait(traitModel : AaiMessageTrait) {
        if(this.traits == null) {
            this.traits = <any>([]);
        }
        /* add */(this.traits.push(traitModel)>0);
    }

    public setIsOneOfMessage(_isOneOfMessage : boolean) {
        this._isOneOfMessage = _isOneOfMessage;
    }
}
AaiMessage["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiMessage";
AaiMessage["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




